<script>
import { Pie } from "vue-chartjs";
import deepmerge from "deepmerge";

import ChartjsPluginDatalabels from "chartjs-plugin-datalabels";

import { noDataFoundPlugin } from "../util/no-data-found-charts";

const onHoverLegend = (_event, legendItem, chart) => {
  const index = chart.data.labels.indexOf(legendItem.text); // index on datalabels
  const activeSegment = chart.getDatasetMeta(0).data[index];

  chart.getDatasetMeta(0).data.forEach((segment, i) => {
    if (i === index) {
      return;
    }
    segment._model.backgroundColor = "#fff";
  });

  activeSegment._model.borderWidth = activeSegment._options.hoverBorderWidth;

  chart.tooltip._active = [activeSegment];
  chart.tooltip.update();
  chart.draw();
};

const onLeaveLegend = (_event, legendItem, chart) => {
  const index = chart.data.labels.indexOf(legendItem.text);
  const activeSegment = chart.getDatasetMeta(0).data[index];

  chart.getDatasetMeta(0).data.forEach((segment, i) => {
    if (i === index) {
      return;
    }
    segment._model.backgroundColor = segment._options.backgroundColor;
  });
  activeSegment._model.borderWidth = activeSegment._options.borderWidth;

  chart.tooltip._active = [];
  chart.tooltip.update();
  chart.draw();
};

// not using vue-chartjs mixin because into them chartData could not be start with null (but for loading this is required)
export default {
  name: "PieChart",
  extends: Pie,
  props: {
    // WIP feature
    enableLegendHover: {
      type: Boolean,
      default: () => false,
    },
    showPercentage: {
      type: Boolean,
      default: () => true,
    },
    showLegend: {
      type: Boolean,
      default: () => true,
    },
    chartData: {
      type: Object,
      default: () => null,
    },
    width: {
      type: Number,
      default: () => undefined,
    },
    height: {
      type: Number,
      default: () => undefined,
    },
    aspectRatio: {
      type: Number,
      default: () => 1.6,
    },
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        aspectRatio: this.aspectRatio,
        legend: {
          display: this.showLegend,
          position: "bottom",
          onHover: (ev, item) =>
            this.enableLegendHover &&
            onHoverLegend(ev, item, this.$data._chart),
          onLeave: (ev, item) =>
            this.enableLegendHover &&
            onLeaveLegend(ev, item, this.$data._chart),
        },
        plugins: {
          datalabels: {
            display: this.showPercentage ? "auto" : false,
            formatter: (value, ctx) => {
              const [{ data: dataset }] = ctx.chart.data.datasets;
              const total = dataset.reduce((acc, curr) => acc + curr, 0);
              const percentage = (value / total) * 100;
              return percentage.toFixed(2) + "%";
            },
            color: "#fff",
          },
        },
      },
    };
  },
  watch: {
    chartData: function () {
      this.renderChart(this.chartData || {}, this.options);
    },
    showPercentage: function (newValue) {
      this.options = deepmerge(this.options, {
        plugins: {
          datalabels: {
            display: newValue ? "auto" : false,
          },
        },
      });
      this.renderChart(this.chartData, this.options);
    },
    enableLegendHover: function (newValue) {
      this.options = deepmerge(this.options, {
        legend: {
          onHover: (ev, item) =>
            newValue && onHoverLegend(ev, item, this.$data._chart),
          onLeave: (ev, item) =>
            newValue && onLeaveLegend(ev, item, this.$data._chart),
        },
      });
      this.renderChart(this.chartData, this.options);
    },
    showLegend: function (newValue) {
      this.options = deepmerge(this.options, {
        legend: {
          display: newValue,
        },
      });
      this.renderChart(this.chartData || {}, this.options);
    },
  },
  mounted() {
    this.addPlugin(ChartjsPluginDatalabels);
    this.addPlugin({
      id: "no-data-found",
      afterDraw: (chart) =>
        noDataFoundPlugin(chart, this.chartData, "Nenhum dado encontrado..."),
    });
    this.renderChart(this.chartData || {}, this.options);
  },
};
</script>
